export function checkEva(): boolean {
  return document.querySelector("meta[name='version']")?.getAttribute("content")?.startsWith("EVA") ?? false;
}
